/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { breakpoints } from '@coursera/cds-core';

import ArticleCardPlaceholder from 'bundles/shared-articles/components/ArticleCardPlaceholder';
import { HUB_CARD_DIMENSIONS } from 'bundles/shared-articles/constants';

const styles = {
  articleCardWrapper: () => css`
    height: ${HUB_CARD_DIMENSIONS.desktop.height}px;
    width: 100%;
    background-color: white;
    box-shadow: 0 2px 10px rgb(0 0 0 / 10%);
    border-radius: 8px;
    ${breakpoints.down('xs')} {
      height: ${HUB_CARD_DIMENSIONS.mobile.height}px;
      width: 100%;
    }
  `,
};

const ArticleHubCardPlaceholder = () => (
  <div css={styles.articleCardWrapper} data-testid="article-hub-card-placeholder">
    <ArticleCardPlaceholder />
  </div>
);

export default ArticleHubCardPlaceholder;
